import React from "react";
import BatchPicker from "./components/BatchPicker";
import WeekPicker from "./components/WeekPicker";
import { Spin } from "antd";
import WeekCalendar from "./components/WeekCalendar";
import style from "./index.module.scss";
import { CourseItem } from "../../../../API";

interface DayItems {
    day: string;
    courses: CourseItem[];
    date: string;
}

interface MainPCProps {
    week: number;
    currentWeek: number;
    onWeekChange: (week: number) => void;
    startDate: string;
    endDate: string;
    loading: boolean;
    data: DayItems[];
}

export default function MainPC({
    week,
    currentWeek,
    data,
    loading,
    onWeekChange,
    startDate,
    endDate
}: MainPCProps) {
    return (
        <div className={style.root}>
            <div className={style.header}>
                <BatchPicker />
                <WeekPicker
                    week={week}
                    currentWeek={currentWeek}
                    onChange={onWeekChange}
                />
            </div>

            <Spin spinning={loading}>
                <WeekCalendar
                    data={data}
                    startDate={startDate}
                    endDate={endDate}
                />
            </Spin>
        </div>
    );
}
